<script setup lang="ts">
import AppIcon from '@/components/ui/AppIcon.vue';
import ThemeToggle from '@/components/ui/ThemeToggle.vue';
</script>

<template>
  <div class="flex min-h-screen flex-col bg-bg">
    <header class="flex items-center gap-4 px-8 py-4">
      <span class="brand-mark">
        <AppIcon name="logo" :size="23" />
      </span>
      <span class="brand-word">kitob<span>xonlik</span></span>
      <span class="ml-auto"><ThemeToggle /></span>
    </header>
    <main class="flex flex-1 items-center justify-center px-4 py-12">
      <slot />
    </main>
  </div>
</template>
